import SessionController from '../session';

const ScormUtilities = {
    // Returns true if the modern SCORM player should be used for the current org/session
    useModernPlayer: function () {
        if (window.ENV?.USE_MODERN_SCORM_PLAYER === true) {
            return true;
        }
        return SessionController.session?.environment?.enableNewScorm;
    },

    // Returns true when the env hasn't forced a player, so the org-level toggle should be shown
    isScormPlayerOrganisationControlled: function () {
        return window.ENV?.USE_MODERN_SCORM_PLAYER === false;
    }
};

export default ScormUtilities;
